module.exports = __webpack_public_path__ + "static/media/chart.ffede630.svg";